import React, { useState, useEffect, useMemo } from "react";
import Header from "./Header";
import QuestionSection from "./QuestionSection";
import QuestionNavigator from "./QuestionNavigator";
import { Box, Container, Drawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import useTestIITStyles from "../testStyle/iitStyle/testIITStyle";
import { useQuestion } from "../../../context/QuestionsContext";
import { useAttemptedQuestions } from "../../../context/AttemptedQuestionsContext";

function TestIIT() {
  const classes = useTestIITStyles();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentSubject, setCurrentSubject] = useState([0]);
  const [subjectId, setSubjectId] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  const { fetchAttemptedQuestions } = useAttemptedQuestions();
  const { question } = useQuestion();

  const questionData = question?.subjects
    ?.map((subject) => subject?.questions)
    .flat();

  const subjectNames = question?.subjects?.map(
    (subject) => subject.subject_name
  );

  const lengths = useMemo(() => {
    if (!question?.subjects) return [];

    return question.subjects.reduce((acc, subject, index) => {
      const prevSum = index > 0 ? acc[index - 1] : 0;
      acc.push(prevSum + subject.questions.length);
      return acc;
    }, []);
  }, [question]);

  useEffect(() => {
    setCurrentSubject((prev) => [...prev, ...lengths]);
  }, [lengths]);

  useEffect(() => {
    let cumulative = 0;
    let subjectIndex = 0;

    for (let i = 0; i < question?.subjects?.length; i++) {
      cumulative += question.subjects[i].questions.length;
      if (currentQuestion < cumulative) {
        subjectIndex = i;
        break;
      }
    }

    const subjectId = question?.subjects[subjectIndex]?.id;
    setSubjectId(subjectId);
  }, [currentQuestion, question]);

  useEffect(() => {
    const storedExamId = sessionStorage.getItem("examId");
    if (storedExamId) {
      fetchAttemptedQuestions(storedExamId);
    }
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Header
          subjectNames={subjectNames}
          currentSubject={currentSubject}
          setCurrentQuestion={setCurrentQuestion}
          currentQuestion={currentQuestion}
          questionData={questionData}
          subjectId={subjectId}
        />
      </Box>

      <Box
        sx={{
          display: { xs: "flex", sm: "none" },
          backgroundColor: "#f7931e",
          width: "100%",
          position: "fixed",
          top: 0,
          zIndex: 1200,
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <IconButton
          color="inherit"
          edge="end"
          onClick={handleDrawerToggle}
          sx={{
            paddingRight: 3,
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>

      <Container className={classes.content}>
        <Box className={classes.left}>
          <QuestionSection
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
            questionData={questionData}
            subjectId={subjectId}
          />
        </Box>

        <Box
          className={classes.right}
          sx={{ display: { xs: "none", sm: "block" } }}
        >
          <QuestionNavigator
            questionData={questionData}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
            subjectId={subjectId}
          />
        </Box>

        <Drawer
          variant="temporary"
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: 325 },
          }}
        >
          <Box>
            <QuestionNavigator
              questionData={questionData}
              currentQuestion={currentQuestion}
              setCurrentQuestion={setCurrentQuestion}
            />
          </Box>
        </Drawer>
      </Container>
    </Box>
  );
}

export default TestIIT;
